export default __webpack_public_path__ + "static/media/Reconciliation.12049554.png";